export interface MapMarker<T = any> {
  coordinates: Array<number>;
  payload?: T;
}
export interface Props<T = any> {
  markers: MapMarker<T>[];
  onClickMarker: (marker: MapMarker<T>) => void;
  initialZoom?: number;
  centerPoint?: Array<number>;
}

export const initialYandexZoomValue = 11;
export const initialGoogleZoomValue = 0.3;
